import { processSteps } from "@/data/process";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const ProcessSection = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative overflow-hidden bg-[#0F172A] py-20 sm:py-24 lg:py-28"
    >
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
          backgroundSize: "40px 40px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="08"
          kicker="Proses"
          title="Bagaimana Proses Maintenance Kami?"
          description="Alur kerja yang terstruktur dari konsultasi awal hingga pemantauan berkelanjutan."
          className="[&_h2]:text-white [&_p]:text-slate-300 [&_.text-slate-500]:text-slate-400"
        />

        <div className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
          {processSteps.map((step, i) => (
            <Reveal key={step.number} delay={(i % 3) * 0.08}>
              <div
                data-testid={`process-step-${step.number}`}
                className="group relative"
              >
                {/* connector line (desktop) */}
                {i < processSteps.length - 1 && (
                  <span className="absolute left-8 top-8 hidden h-px w-[calc(100%+1.5rem)] bg-white/10 lg:block" />
                )}
                <div className="relative flex items-start gap-5">
                  <span className="relative z-10 flex h-16 w-16 flex-none items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] text-2xl font-extrabold tabular-nums text-[#E0A400] transition-colors duration-300 group-hover:border-[#E0A400]/50 group-hover:bg-[#E0A400]/10">
                    {step.number}
                  </span>
                  <div className="pt-1.5">
                    <h3 className="text-lg font-bold text-white">{step.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
